function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function PlansAndPricing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17",
    height: "16",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.778 2.4414c0-.5523.4476-1 1-1h6.0587l3.2942 2.8235v9.353c0 .5523-.4478 1-1 1h-8.353c-.5523 0-1-.4477-1-1V2.4414Z",
    fill: "#BFF6F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6518 1.9414H4.7779a.5.5 0 0 0-.5.5V13.618a.5.5 0 0 0 .5.5h8.353a.5.5 0 0 0 .5-.5v-9.123l-2.9791-2.5535Zm.1849-.5H4.7779c-.5523 0-1 .4477-1 1V13.618c0 .5523.4477 1 1 1h8.353c.5522 0 1-.4477 1-1v-9.353l-3.2942-2.8235Z",
    fill: "#528693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0814 4.4614a.5.5 0 0 1-.5288-.5562l.2838-2.464L14.131 4.265l-3.0496.1964Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.2255 2.4332-.1762 1.5292 1.8234-.1174-1.6472-1.4118Zm-.6729 1.472a.5.5 0 0 0 .5288.5562l3.0496-.1964-3.2946-2.8238-.2838 2.464Z",
    fill: "#528693"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4757 10.6548c-.9843-.1406-.918-1.583.0751-1.6326l.333.0292.0274.5466-.333-.0292c-.331.0165-.3532.4973-.025.5442l6.4871.9268L8.959 9.598a.2737.2737 0 0 1 .4378-.3284l1.4777 1.9703a.2737.2737 0 0 1-.0547.3832l-1.9704 1.4777a.2737.2737 0 0 1-.3283-.4379l1.4418-1.0813-6.4872-.9268Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m3.5583 8.6213.7076.0621.0568 1.1355 4.8182.6883-.502-.6692a.6737.6737 0 0 1 1.0779-.8084L11.1945 11a.6736.6736 0 0 1-.1348.9431l-1.9703 1.4777a.6736.6736 0 0 1-.8083-1.0779l.6692-.5019-5.5312-.7902c-1.4638-.2092-1.3653-2.3543.1117-2.4282l.0275-.0013Zm-.0826 2.0335c-.9843-.1406-.918-1.583.0751-1.6326l.333.0292.0274.5466-.333-.0292a.308.308 0 0 0-.0685.011c-.264.0743-.2604.4898.0434.5332l6.4872.9268L8.9589 9.598a.2737.2737 0 0 1 .4379-.3284l1.4777 1.9703a.2738.2738 0 0 1-.0547.3832l-1.9704 1.4777a.2737.2737 0 0 1-.3283-.4379l1.4417-1.0813-6.487-.9268Z",
    fill: "#528693"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5734 6.6087c.9087.1299.8475 1.4614-.0694 1.5073l-.4259.0551-.0253-.5046.426-.0552c.3056-.0153.326-.4591.0231-.5024L8.513 6.2533l.9983 1.331a.2526.2526 0 1 1-.4042.3032l-1.3642-1.819a.2526.2526 0 0 1 .0505-.3537l1.819-1.3642a.2526.2526 0 1 1 .3031.4042l-1.331.9983 5.9889.8556Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5734 6.6087c.9087.1299.8475 1.4614-.0693 1.5073l-.426.0551-.0253-.5046.426-.0552c.3056-.0153.326-.4591.0231-.5024l-5.9888-.8556.9982 1.331a.2526.2526 0 0 1-.4042.3032l-1.3642-1.819a.2513.2513 0 0 1-.039-.2273.2514.2514 0 0 1 .0895-.1264l1.819-1.3642a.2526.2526 0 0 1 .3032.4042l-1.331.9983 5.9888.8556Zm-4.9763-1.115 5.0329.719c1.3826.1976 1.2955 2.2162-.0889 2.3018l-.8409.109-.0617-1.2339-4.226-.6037.4188.5584a.6526.6526 0 1 1-1.0442.7832l-1.3642-1.819a.6526.6526 0 0 1 .1305-.9137l1.819-1.3642a.6526.6526 0 0 1 .7832 1.0442l-.5585.4189Z",
    fill: "#528693"
  }));
}

export default PlansAndPricing;